import { useAuth as useAuthContext } from '@/lib/auth';

export function useAuth() {
  const auth = useAuthContext();
  return {
    ...auth,
    isAuthenticated: !!auth.user,
  };
}
